import React from 'react';
import ReactDOM from 'react-dom/client';

// Import the styles which includes CKEditor styles
import { importStyles } from '@loyalty-system/react-web-ui-shadcn';

import App from './App';
// eslint-disable-next-line no-restricted-imports
import '@loyalty-system/react-web-ui-shadcn/globals.scss';
import '@/globals.scss';

// Call the function to ensure styles are loaded
importStyles();

const domElementId = 'root';
const rootElement = document.getElementById(domElementId);

if (!rootElement) {
  throw new Error(`Element with id ${domElementId} not found`);
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
